import React from "react";

declare global {
    interface Window {
        layoutMode: 'ios' | 'md';
        cartTotal: any;
        initials: any;
        storage: any;
        flutter_inappwebview: any;
        activeRedux: any,
        modalContainer: any
    }

    // interface Object {
    //     isEmpty(): boolean
    // }

    interface Number {
        toThousandSep(): string,
        toPrice(): string
    }
}

export const reactIsInDevelopmentMode = ('_self' in React.createElement('div'));

export const baseUrl = reactIsInDevelopmentMode ? 'http://localhost/nazretabiat' : 'https://www.nazretabiat.ir'

export const setTokens = async (access_token: any, refresh_token: any) => {
    if (isWebView()) {
        passToWebView("setPref", "access_token", access_token);
        passToWebView("setPref", "refresh_token", refresh_token);
    } else {
        let tokens = { access_token: access_token, refresh_token: refresh_token };

        await window.storage.set("user", tokens);
    }
}

export const objIsEmpty = (obj: Object) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    
    return true;
}

export const decodeString = (text?: any) => {
    if (text === undefined) return "";
    let t = text!; 
    t = t.replace(/\+/g, ' ');
    t = decodeURIComponent(t);
    return t;
}

export const isHome = () => {
    return window.location.pathname == "/"
}

export const isWebView = () => {
    return window.flutter_inappwebview !== undefined;
}

// تابع ارتباط وب اپ با WebView
export const passToWebView = (name: any, ...args: any) => {
    if (isWebView()) {
        return window.flutter_inappwebview?.callHandler(name, ...args);
    } else {
        window.location.href = args[0];
        // window.open(args[0], "_blank")
    }
}

export const arrayIsEmpty = (array: []) => {
    return array.length == 0;
}

Number.prototype.toThousandSep = function (): string {
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،");
}

Number.prototype.toPrice = function (): string {
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،") + ' ریال';
}

export { }